/* eslint-disable linebreak-style */
import React from "react";
import "./LoginFailed.css"
// import logo from "../../assets/images/logo.png";
import { useTranslation } from "react-i18next";
import logo from "../../assets/images/logo.svg";

// Can be a string as well. Need to ensure each key-value pair ends with ;


function LoginFailed() {
    
    const {t} = useTranslation()

    return (
        <React.Fragment>
            <div className='signin-block'>
                <div className='main-block'>
                    <div className='container'>
                        <div className="login-block-txt">
                            <div className='login-box'>
                                {/* <h1 className="headding-title">{t("loginFailed-text-1")} </h1> */}
                                <img src={logo} className='mb-4' alt='' />
                                <div className='login-text my-4'>
                                    <p>It seems you do not have access to this portal at the moment.<br>
                                    </br>Please connect with <a href='mailTo:DX-SIO-Enablement@adobe.com'>DX-SIO-Enablement@adobe.com</a> for further assistance.</p>
                                </div>
                                <a type="button" className=" fill" href="mailTo:DX-SIO-Enablement@adobe.com">{t("contact-admin-val", {val:"Adobe"})}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer>
                <div className='container'>
                    <div className='row footer-block'>
                        <div className='footer-txt col'>
                            {t("powred-by-adobe")}
                        </div>
                    </div>

                </div>
            </footer>
        </React.Fragment >
    );
}


export default LoginFailed;